import { render, staticRenderFns } from "./PassengerSegList.vue?vue&type=template&id=85186cda&"
import script from "./PassengerSegList.vue?vue&type=script&lang=js&"
export * from "./PassengerSegList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports